import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { FormTextareaSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { INPUT_LIMITS } from "../../input-limits";

export const FormTextarea = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
    actions: { selectNode },
  } = useEditor();

  const {
    placeholderText,
    autofocus,
    cols,
    disabled,
    maxlength,
    name,
    readonly,
    required,
    rows,
    wrap,
    value,
    showLabel,
    label,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-form-textarea": true,
      [`form-textarea-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__FormTextarea(id, props)}`}</style>
      {showLabel && (
        <label htmlFor={`form-textarea-${id}`}>
          {label ? label : "Label"}
          {required && <span className="required">*</span>}
        </label>
      )}
      <textarea
        minLength={INPUT_LIMITS["form-textarea"].minlength}
        className="form-textarea-field"
        placeholder={placeholderText}
        maxLength={
          maxlength ? maxlength : INPUT_LIMITS["form-textarea"].minlength
        }
        autoFocus={autofocus ? autofocus : undefined}
        cols={cols ? cols : undefined}
        rows={rows ? rows : 8}
        readOnly={readonly ? readonly : undefined}
        wrap={wrap ? wrap : undefined}
        required={required ? required : undefined}
        name={name ? name : undefined}
        disabled={disabled ? disabled : undefined}
        value={value ? value : undefined}
      ></textarea>
    </div>
  );
};

// To Avoid Mangling in Production
FormTextarea.displayName = "FormTextarea";

FormTextarea.craft = {
  name: "Textarea",
  props: {},
  related: {
    icon: icon,
    category: "form",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    settings: FormTextareaSettings,
    keywords: ["Form Textarea", "Long message", "paragraph"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Form Textarea",
    slug: "grigora/form-textarea",
  },
};
